import { isDefined } from "@clipboard-health/util-ts";
import { useGetPreference } from "@src/appV2/redesign/utils/useGetPreference";

export const LASTEST_ORIENTATION_FAILURE_ALERT_EVENT_ID_KEY =
  "lastest-orientation-failure-alert-event-id";

export function useHasSeenLastestOrientationFailureAlert(eventId: string | undefined) {
  const {
    data: lastestOrientationFailureAlertEventId,
    isLoading,
    isSuccess,
  } = useGetPreference(LASTEST_ORIENTATION_FAILURE_ALERT_EVENT_ID_KEY);

  return {
    isLoading,
    hasSeenLastestOrientationFailureAlert:
      isDefined(eventId) && isSuccess
        ? lastestOrientationFailureAlertEventId === eventId
        : // We will assume that the worker has seen the orientation failure alert by default.
          // Doing so prevents the display of the orientation failure alert when the state is being loaded asynchronously.
          true,
  };
}
